import { splitLinks } from '@goaltree/backend/convex/lib/linkLabel'
import { ExternalLink } from 'lucide-react'
import { useMemo } from 'react'

export function LinkChip({ url, label }: { url: string; label: string }) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      title={url}
      onClick={(e) => e.stopPropagation()}
      onPointerDown={(e) => e.stopPropagation()}
      className="not-prose mx-px inline-flex max-w-full items-center gap-1 rounded-md border border-border/60 bg-muted/50 px-1.5 align-bottom text-[0.92em] leading-[1.45] font-medium text-primary-text no-underline transition-colors hover:bg-muted hover:text-primary-text/80"
    >
      <span className="min-w-0 truncate">{label}</span>
      <ExternalLink className="size-[0.85em] shrink-0 opacity-70" aria-hidden />
    </a>
  )
}

export function LinkifiedText({ text, className }: { text: string; className?: string }) {
  const parts = useMemo(() => splitLinks(text), [text])
  const body = parts.map((p, i) =>
    p.type === 'link' ? <LinkChip key={i} url={p.url} label={p.label} /> : p.text,
  )
  return className ? <span className={className}>{body}</span> : <>{body}</>
}
